import { useState } from "react";
import Cookies from "js-cookie";

const useCookies = (key, initialValue) => {
    const [cookieValue, setCookieValue] = useState(() => {
        var value = Cookies.get(key);
        if(!value){
            value = initialValue;
        }else{
            try {
                value = JSON.parse(value);                
            } catch (error) {
                return null;
            }
        }
        return value;
    });

    const setCookie = (value, options = {}) => {
        var data = JSON.stringify(value);
        Cookies.set(key, data, options);
    };

    const removeCookie = () => {
        setCookieValue(null);
        Cookies.remove(key);
    };

    return [cookieValue, setCookie, removeCookie];
};

export default useCookies;
